import React, { useState } from 'react';
import { CheckCircle, XCircle, Award, RotateCcw, ChevronRight, ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const QUESTIONS = [
  { id: "1", q: "¿Cuáles son las 8 divisas principales del Mercado de Forex?", options: [
    { key: "a", text: "Dólar, Yen, Libra, Euro, Canadiense, Franco, Australiano, Neozelandés" },
    { key: "b", text: "Dólar, Euro, Libra, Peso Mexicano, Franco, Australiano, Yuan, Canadiense" },
    { key: "c", text: "Euro, Libra, Dólar, Yuan, Corona, Canadiense, Australiano, Neozelandés" },
  ]},
  { id: "2", q: "¿Qué son las noticias fundamentales en el trading?", options: [
    { key: "a", text: "Eventos económicos, macroeconómicos y políticos que impactan directamente en el valor y la tendencia de los activos financieros" },
    { key: "b", text: "Patrones geométricos que se forman exclusivamente en las velas japonesas dentro del gráfico técnico" },
    { key: "c", text: "Indicadores matemáticos que calculan automáticamente el promedio móvil de los últimos 14 días" },
  ]},
  { id: "3", q: "¿Cuáles son las principales sesiones del mercado Forex?", options: [
    { key: "a", text: "Sesión de Nueva York, Sesión de Londres, Sesión de Tokio y Sesión de Sídney" },
    { key: "b", text: "Sesión de Criptomonedas, Sesión de Acciones, Sesión de Futuros y Sesión de Bonos" },
    { key: "c", text: "Sesión Matutina, Sesión Vespertina, Sesión Nocturna y Sesión de Madrugada" },
  ]},
  { id: "4", q: "¿Cuál de las 4 sesiones principales del mercado Forex es la que mueve el mayor volumen de dinero y liquidez a nivel mundial?", options: [
    { key: "a", text: "Sesión de Nueva York" },
    { key: "b", text: "Sesión de Londres" },
    { key: "c", text: "Sesión de Tokio" },
    { key: "d", text: "Sesión de Sídney" },
  ]},
  { id: "5", q: "¿En qué consistía el sistema de trueque en la historia del comercio?", options: [
    { key: "a", text: "En la compra y venta de bienes únicamente utilizando monedas de oro y plata" },
    { key: "b", text: "En el intercambio directo de bienes o servicios por otros bienes o servicios, sin la intervención de dinero" },
    { key: "c", text: "En un sistema bancario primitivo basado en notas de crédito escritas en papel" },
  ]},
  { id: "6", q: "¿Qué acontecimiento histórico clave para el sistema financiero internacional tuvo lugar en los Acuerdos de Bretton Woods en 1944?", options: [
    { key: "a", text: "Se creó el mercado Forex descentralizado y se dio inicio a la libre flotación de las divisas a nivel mundial" },
    { key: "b", text: "Se estableció el patrón dólar-oro, fijando el dólar estadounidense como la moneda de reserva global respaldada por oro" },
    { key: "c", text: "Se eliminó de manera definitiva el dinero fiduciario para regresar al intercambio exclusivo de trueque entre naciones" },
  ]},
  { id: "7", q: "¿Cuáles son los principales participantes del mercado financiero y de Forex?", options: [
    { key: "a", text: "Exclusivamente los traders minoristas (retail traders) que operan desde sus casas" },
    { key: "b", text: "Únicamente las entidades reguladoras internacionales y los gobiernos nacionales" },
    { key: "c", text: "Bancos centrales, bancos comerciales e inversión, fondos de cobertura (hedge funds), corporaciones y traders minoristas" },
    { key: "d", text: "Empresas de transporte marítimo, casas de empeño local y casas de cambio informales" },
  ]},
  { id: "8", q: "¿Qué es la volatilidad en los mercados financieros?", options: [
    { key: "a", text: "La velocidad a la que la cuenta de un trader se cierra automáticamente por falta de margen" },
    { key: "b", text: "La constante estabilidad de un activo cuando su precio no sufre ningún tipo de cambio durante el día" },
    { key: "c", text: "La medida de la intensidad, frecuencia y magnitud con la que varía el precio de un activo financiero en un periodo determinado" },
    { key: "d", text: "El cobro de comisión que aplican los brokers al mantener una operación abierta de un día para otro" },
  ]},
  { id: "9", q: "¿Qué es el volumen en el trading y los mercados financieros?", options: [
    { key: "a", text: "La velocidad o fuerza con la que una tendencia se mueve en el gráfico técnico" },
    { key: "b", text: "La cantidad total de contratos o unidades de un activo que se compran y venden durante un período determinado" },
    { key: "c", text: "El apalancamiento máximo que permite utilizar un broker en una cuenta de trading" },
    { key: "d", text: "La diferencia de precio que existe entre el punto más alto y el más bajo del día" },
  ]},
  { id: "10", q: "¿Cómo se identifican y ubican correctamente los niveles de soporte y resistencia en un gráfico de trading?", options: [
    { key: "a", text: "Identificando zonas horizontales donde el precio ha rebotado o cambiado de dirección múltiples veces en el pasado" },
    { key: "b", text: "Trazando una línea recta horizontal únicamente en el precio donde abrió la primera vela del año" },
    { key: "c", text: "Utilizando exclusivamente el valor del margen libre disponible en la cuenta del broker" },
    { key: "d", text: "Colocándolos de forma aleatoria en los puntos donde el indicador de volumen alcance su nivel más bajo" },
  ]},
  { id: "11", q: "¿Cuáles son las 4 fases fundamentales que componen el ciclo de mercado según el análisis técnico?", options: [
    { key: "a", text: "Apertura, Cierre, Máximo y Mínimo" },
    { key: "b", text: "Compra, Venta, Apalancamiento y Liquidación" },
    { key: "c", text: "Acumulación, Tendencia Alcista (Markup), Distribución y Tendencia Bajista (Markdown)" },
    { key: "d", text: "Sesión Asiática, Sesión Europea, Sesión Americana y Sesión Australiana" },
  ]},
  { id: "12", q: "En la gestión del lote en Forex, ¿cuál es el orden correcto que relaciona el Nombre del lote, su Tamaño en unidades de divisa y su Valor aproximado por pip?", options: [
    { key: "a", text: "Lote Estándar (10,000 / $1 pip), Mini (1,000 / $0.10 pip), Micro (100,000 / $10 pip)" },
    { key: "b", text: "Lote Estándar (100,000 / $10 pip), Mini (10,000 / $1 pip), Micro (1,000 / $0.10 pip)" },
    { key: "c", text: "Lote Estándar (1,000 / $0.10 pip), Mini (100,000 / $10 pip), Micro (10,000 / $1 pip)" },
    { key: "d", text: "Lote Estándar (100,000 / $1 pip), Mini (10,000 / $10 pip), Micro (1,000 / $0.10 pip)" },
  ]},
  { id: "13", q: "¿Cómo se identifica correctamente un Imbalance (Ineficiencia o Fair Value Gap) en un gráfico de velas japonesas?", options: [
    { key: "a", text: "Identificando el punto donde el indicador RSI cruza el nivel de 70 en sobrecompra" },
    { key: "b", text: "Observando un patrón de velas donde existe un agotamiento del precio dejando liquidez y luego sale con una vela de poder" },
    { key: "c", text: "Ubicando la vela doji de menor volumen al cierre de la sesión de Nueva York" },
    { key: "d", text: "Marcando únicamente el espacio que queda abierto entre el cierre del viernes y la apertura del domingo" },
  ]},
  { id: "15", q: "Según el modelo de Patrones de Continuidad (CP), ¿cuál es la regla fundamental para validar la Base de la estructura antes de buscar una entrada?", options: [
    { key: "a", text: "La base debe tener más de 10 velas consecutivas sin importar el cuerpo o la mecha" },
    { key: "b", text: "No se puede tener más de 5 velas en la consolidación/base y debe existir simetría en las velas de formación" },
    { key: "c", text: "La zona de demanda solo se habilita marcando únicamente la mecha superior de la vela más alta" },
    { key: "d", text: "Se habilita una zona de compra cuando el precio rompe un soporte hacia abajo" },
  ]},
  { id: "16", q: "¿Cuáles son los 5 mandamientos para validar una zona de Oferta y Demanda de alta probabilidad?", options: [
    { key: "a", text: "Movimiento lento, no romper estructura, riesgo 1:1, zona testeada múltiples veces, operar sin importar temporalidad" },
    { key: "b", text: "Movimiento acelerado y consolidación afuera, rompimiento de estructura y/o zona opuesta, riesgo mínimo 1:2-1:3, zona fresca y alineación con temporalidad mayor" },
    { key: "c", text: "RSI en sobrecompra, cruce de medias móviles, volumen bajo, retesteo múltiple, entrada en gráfico de 1 segundo" },
    { key: "d", text: "Entrada sin stop loss, riesgo negativo, zona usada, contra tendencia, consolidación dentro de zona" },
  ]},
  { id: "17", q: "Según los criterios del concepto Arrival Zone, ¿cuáles son sus características principales?", options: [
    { key: "a", text: "Se busca en temporalidades de 1 minuto, elimina la zona opuesta, probabilidad del 50%" },
    { key: "b", text: "Temporalidades superiores a semanales (H4 para scalping), rompe línea de tendencia, elimina zonas intermedias, 95% de probabilidad hacia zona opuesta" },
    { key: "c", text: "Solo para Stop Loss, requiere que el precio respete todas las zonas intermedias" },
    { key: "d", text: "Punto medio de consolidación en gráficos de 15 minutos" },
  ]},
  { id: "18", q: "¿Cómo se definen y diferencian los conceptos de 'Control' y 'Tendencia' entre distintas temporalidades?", options: [
    { key: "a", text: "El control es la dirección semanal, la tendencia es el movimiento en gráficos de 1 minuto" },
    { key: "b", text: "El control indica quién dominó el precio en menor temporalidad (M15) hacia la zona opuesta, la tendencia señala la dirección estructural en mayor temporalidad (H1/H4)" },
    { key: "c", text: "Son términos idénticos que indican el cruce de medias móviles" },
    { key: "d", text: "La tendencia nace al romper demanda, el control se mantiene sin movimientos" },
  ]},
];

export default function CertificationExam({ onPass, onClose }) {
  const [currentQ, setCurrentQ] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const question = QUESTIONS[currentQ];
  const totalQ = QUESTIONS.length;
  const answered = Object.keys(answers).length;

  const selectAnswer = (qId, key) => {
    setAnswers({ ...answers, [qId]: key });
  };

  const handleSubmit = async () => {
    if (answered < totalQ) {
      toast.error(`Responde todas las preguntas (${answered}/${totalQ})`);
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/exam/submit`, { answers });
      setResult(res.data);
      if (res.data.passed) {
        toast.success(`Aprobaste con ${res.data.score}%`);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al enviar examen');
    } finally {
      setSubmitting(false);
    }
  };

  // Result screen
  if (result) {
    return (
      <div className="fixed inset-0 z-[90] bg-black/95 overflow-y-auto" data-testid="exam-result">
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="w-full max-w-lg">
            <div className="glass-panel rounded-lg p-8 text-center alien-glow">
              <div className="mb-6">
                {result.passed ? (
                  <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Award className="h-10 w-10 text-green-400" />
                  </div>
                ) : (
                  <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <XCircle className="h-10 w-10 text-red-400" />
                  </div>
                )}
                <h2 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  <span className={result.passed ? 'text-green-400' : 'text-red-400'}>
                    {result.passed ? 'APROBADO' : 'NO APROBADO'}
                  </span>
                </h2>
                <p className={`text-5xl font-bold mb-2 ${result.passed ? 'text-green-400' : 'text-red-400'}`} style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  {result.score}%
                </p>
                <p className="text-emerald-100/60">{result.correct} de {result.total} respuestas correctas</p>
                <p className="text-emerald-100/40 text-sm mt-1">Mínimo requerido: 80%</p>
              </div>

              {result.passed ? (
                <Button onClick={() => onPass?.()} className="w-full bg-green-500 text-black hover:bg-green-400 font-bold py-5 text-lg" data-testid="exam-get-diploma">
                  <Award className="h-5 w-5 mr-2" /> Obtener Diploma
                </Button>
              ) : (
                <div className="space-y-3">
                  <p className="text-emerald-100/50 text-sm">Revisa los videos y vuelve a intentarlo. Necesitas al menos 80%.</p>
                  <Button onClick={() => { setResult(null); setCurrentQ(0); setAnswers({}); }} className="w-full bg-emerald-500 text-black hover:bg-emerald-400 font-bold" data-testid="exam-retry">
                    <RotateCcw className="h-4 w-4 mr-2" /> Intentar de Nuevo
                  </Button>
                  <button onClick={onClose} className="text-emerald-100/40 text-sm hover:text-emerald-400">Volver a videos</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[90] bg-black/95 overflow-y-auto" data-testid="exam-screen">
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-2xl">
          <div className="glass-panel rounded-lg p-6 sm:p-8 alien-glow">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl font-bold text-emerald-50" style={{ fontFamily: 'Rajdhani, sans-serif' }}>EVALUACIÓN DE CERTIFICACIÓN</h2>
                <p className="text-emerald-100/50 text-xs">Necesitas 80% para aprobar ({Math.ceil(totalQ * 0.8)} de {totalQ})</p>
              </div>
              <button onClick={onClose} className="text-emerald-100/30 hover:text-red-400 text-sm">Cancelar</button>
            </div>

            {/* Progress */}
            <div className="flex items-center space-x-3 mb-6">
              <div className="flex-1 h-2 bg-black/40 rounded-full overflow-hidden">
                <div className="h-full bg-emerald-500 rounded-full transition-all" style={{ width: `${((currentQ + 1) / totalQ) * 100}%` }} />
              </div>
              <span className="text-emerald-400 text-sm font-bold">{currentQ + 1}/{totalQ}</span>
            </div>

            {/* Question */}
            <div className="mb-6">
              <p className="text-emerald-50 font-bold text-lg mb-4">{question.q}</p>
              <div className="space-y-2">
                {question.options.map((opt) => {
                  const selected = answers[question.id] === opt.key;
                  return (
                    <button
                      key={opt.key}
                      onClick={() => selectAnswer(question.id, opt.key)}
                      className={`w-full text-left p-3.5 rounded-lg border-2 transition-all ${
                        selected
                          ? 'border-emerald-500 bg-emerald-500/10'
                          : 'border-emerald-500/20 bg-black/30 hover:border-emerald-500/40'
                      }`}
                      data-testid={`option-${question.id}-${opt.key}`}
                    >
                      <div className="flex items-start space-x-3">
                        <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${
                          selected ? 'bg-emerald-500 text-black' : 'bg-black/40 text-emerald-100/50'
                        }`}>
                          {opt.key.toUpperCase()}
                        </span>
                        <span className={`text-sm ${selected ? 'text-emerald-50' : 'text-emerald-100/70'}`}>{opt.text}</span>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Navigation */}
            <div className="flex items-center justify-between">
              <Button
                onClick={() => setCurrentQ(Math.max(0, currentQ - 1))}
                disabled={currentQ === 0}
                variant="outline"
                className="border-emerald-500/30 text-emerald-400 disabled:opacity-30"
                data-testid="exam-prev"
              >
                <ChevronLeft className="h-4 w-4 mr-1" /> Anterior
              </Button>

              <div className="flex flex-wrap justify-center gap-1">
                {QUESTIONS.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrentQ(i)}
                    className={`w-6 h-6 rounded text-[10px] font-bold transition-all ${
                      i === currentQ
                        ? 'bg-emerald-500 text-black'
                        : answers[QUESTIONS[i].id]
                          ? 'bg-emerald-500/30 text-emerald-400'
                          : 'bg-black/30 text-emerald-100/30'
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>

              {currentQ < totalQ - 1 ? (
                <Button
                  onClick={() => setCurrentQ(currentQ + 1)}
                  className="bg-emerald-500 text-black hover:bg-emerald-400"
                  data-testid="exam-next"
                >
                  Siguiente <ChevronRight className="h-4 w-4 ml-1" />
                </Button>
              ) : (
                <Button
                  onClick={handleSubmit}
                  disabled={submitting || answered < totalQ}
                  className="bg-green-500 text-black hover:bg-green-400 font-bold"
                  data-testid="exam-submit"
                >
                  {submitting ? 'Enviando...' : `Enviar (${answered}/${totalQ})`}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
